import React, { useContext, useRef, useState } from "react";

import emailjs from "@emailjs/browser";
import "./Contact.css";

import { IoLocationSharp, IoCallSharp, IoMailSharp } from "react-icons/io5";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import ContactAnimation from "./lottie.json";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Theme } from "../App";

function Contact() {
  const { theme } = useContext(Theme);

  //Form

  const form = useRef();

  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    message: "",
  });

  const formChangeHandle = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ytrpdeu",
        "template_5legcxx",
        form.current,
        "Gfk2rWqZNfoDIG1VZ"
      )

      .then(
        (result) => {
          console.log(result.text);
          setFormData({
            user_name: "",
            user_email: "",
            message: "",
          });
          toast.success("Message Sent Succesfully");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div id="contact-comp" className={`contact-comp contact-comp-${theme}`}>
      <div id="contact-form">
        <form ref={form} onSubmit={sendEmail}>
          <h1 className="form-heading">Drop a Message</h1>
          <p className="form-subheading">
            Fill out the form and I'll reach out to you shortly!
          </p>

          <input
            onChange={formChangeHandle}
            value={formData.user_name}
            required={true}
            minLength={2}
            type="text"
            name="user_name"
            placeholder="Your Name *"
          />

          <input
            onChange={formChangeHandle}
            value={formData.user_email}
            required={true}
            minLength={5}
            type="email"
            name="user_email"
            placeholder="Your Email *"
          />

          <textarea
            onChange={formChangeHandle}
            value={formData.message}
            required={true}
            minLength={1}
            name="message"
            placeholder="Your Message*"
          />

          <input className="submit-btn" type="submit" value="Send" />
        </form>
        <div id="contact-animation">
          <Lottie animationData={ContactAnimation} />
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}

export default Contact;
